
import { Vue, Component, Prop } from 'vue-property-decorator'
import setting from '@/settings'
import dayjs from 'dayjs'

@Component({
  name: 'detailview'
})

export default class DetailView extends Vue {
  private dayjs = dayjs
  get settlementState () {
    return this.params.settlementState === 1 ? 3 : 4
  }

  @Prop({ type: Object })
  private params!: object|any

  get file1Src () {
    return setting.ossIp + '/' + this.params.idCardFullfacePhotoPath
  }

  get file2Src () {
    return setting.ossIp + '/' + this.params.idCardReversePhotoPath
  }
}
